// 定义一个接口来描述解析后的内容对象
export interface ParsedContent {
    type: 'text' | 'code' | 'code_result' | 'task' | 'input'; // 可能的内容类型：'text'、'code' 或 'code_result'
    content: string; // 实际内容
    status: 'running' | 'finish'; // 内容状态：'running' 表示没有闭合标签，'finish' 表示有闭合标签
    attributes?: Record<string, string>; // 可选的属性对象
}

export const parseContent = (input: string): ParsedContent[] => {
    const result: ParsedContent[] = []; // 用于存储解析后的内容对象数组
    let currentIndex = 0; // 当前处理的字符串位置索引
    const length = input.length; // 输入字符串的总长度

    const handleTag = (type: 'code' | 'code_result' | 'task' | 'input', tagNameLength: number, endTag: string) => {
        currentIndex += tagNameLength; // 跳过标签名称部分，移动索引位置
        const endTagIndex = input.indexOf('>', currentIndex); // 查找 > 标签的结束位置

        if (endTagIndex === -1) return null;

        const tagContent = input.substring(currentIndex, endTagIndex).trim();
        const attributes = parseAttributes(tagContent);
        currentIndex = endTagIndex + 1; // 跳过 > 标签的长度，移动索引位置

        const endCodeTagIndex = input.indexOf(endTag, currentIndex); // 查找结束标签的位置

        if (endCodeTagIndex !== -1) {
            result.push({
                type,
                content: input.substring(currentIndex, endCodeTagIndex).trim(), // 提取标签内的内容并去除空格
                status: 'finish', // 设置状态为 'finish' 表示闭合
                attributes: attributes, // 添加属性对象
            });
            currentIndex = endCodeTagIndex + endTag.length; // 跳过结束标签的长度，继续处理后续内容
        } else {
            result.push({
                type,
                content: input.substring(currentIndex).trim(), // 提取从标签到字符串末尾的内容
                status: 'running', // 设置状态为 'running' 表示未闭合
                attributes: attributes, // 添加属性对象
            });
            return false; // 结束解析，因为已经到达字符串末尾
        }

        return true;
    };

    // 使用 while 循环逐字符解析输入字符串
    while (currentIndex < length) {
        if (input.startsWith('<code', currentIndex)) {
            if (input.startsWith('<code_result', currentIndex)) {
                // 处理 <code_result> 标签
                if (!handleTag('code_result', 12, '</code_result>')) break;
            } else {
                // 处理 <code> 标签
                if (!handleTag('code', 5, '</code>')) break;
            }
        } else if (input.startsWith('<yayi-collapse', currentIndex)) {
            // 处理 <yayi-collapse> 标签
            if (!handleTag('code', 13, '</yayi-collapse>')) break;
        } else if (input.startsWith('<yayi-card', currentIndex)) {
            // 处理 <yayi-card> 标签
            if (!handleTag('task', 9, '</yayi-card>')) break;
        }  else if (input.startsWith('<yayi-input', currentIndex)) {
            if (!handleTag('input', 10, '</yayi-input>')) break;
        }  else {
            // 处理文本内容，找到下一个标签的开始位置
            const nextTagMatch = input.slice(currentIndex).match(/<code\b|<code_result\b|<yayi-collapse\b|<yayi-card\b|<yayi-input\b/);

            if (nextTagMatch) {
                // 如果找到下一个标签
                const nextTagIndex = currentIndex + nextTagMatch.index!;
                result.push({
                    type: 'text',
                    content: input.substring(currentIndex, nextTagIndex).trim(),
                    status: 'finish',
                });
                currentIndex = nextTagIndex; // 更新索引位置以继续处理标签
            } else {
                // 如果没有找到下一个标签，意味着后续都是文本内容
                result.push({
                    type: 'text',
                    content: input.substring(currentIndex).trim(),
                    // status: 'finish',处理动图不显示问题
                    status: 'running',
                });
                break; // 结束解析，因为已经到达字符串末尾
            }
        }
    }
     // 清洗数据，将 type 为 input 的元素包裹在一个 inputGroup 层级中
     const cleanedResult = wrapInputsInInputGroup(result);

     return cleanedResult; // 返回解析后的内容对象数组
};

const wrapInputsInInputGroup = (result: ParsedContent[]): ParsedContent[] => {
    const wrappedResult: ParsedContent[] = [];
    let currentInputGroup: ParsedContent | null = null;

    result.forEach(item => {
        if (item.type === 'input') {
            if (!currentInputGroup) {
                currentInputGroup = {
                    type: 'inputGroup',
                    content: '',
                    status: 'finish',
                    items: [],
                };
                wrappedResult.push(currentInputGroup);
            }
            currentInputGroup.items!.push(item);
        } else {
            if (currentInputGroup) {
                currentInputGroup = null;
            }
            wrappedResult.push(item);
        }
    });
    
    return wrappedResult;
};
// 辅助函数：解析标签中的属性
const parseAttributes = (tagContent: string): Record<string, any> => {
    const attributes: Record<string, any> = {};
    // 支持单引号和双引号的正则表达式
    const attributeRegex = /([\w-]+)\s*=\s*(['"])(.*?)\2/g;
    let match;

    while ((match = attributeRegex.exec(tagContent)) !== null) {
        let value = match[3];
        try {
            // 尝试将值解析为 JSON 对象
            if (match[1] == 'data-vals') {
                value = JSON.parse(value);
            }
            
        } catch (e) {
            // 如果解析失败，保持原始值
        }
        attributes[match[1]] = value;
    }
    return attributes;
};